import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {gsap, Linear} from "gsap";
import {BruteForce} from "../BruteForce";
import {BruteForceGameConfig} from "../BruteForceGameConfig";
import {BruteForceHelper} from "../utils/BruteForceHelper";
import {BruteForceSymbol, BruteForceSymbolStates} from "../reels/BruteForceSymbol";
import {BruteForceXNudgeSymbol} from "../reels/BruteForceXNudgeSymbol";
import {CustomWiggle} from "gsap/dist/CustomWiggle";
import {BruteForceBetlineConfig} from "../BruteForceBetlineConfig";


export class BruteForceReelOverlayView extends PIXI.Container implements StageLayer {

    constructor() {
        super();
        this.name = "BruteForceReelOverlayView";
        this.init();
    }

    public showNudgeReelHighlight(reelID: number): gsap.core.Timeline {
        const reelHighlightTl: gsap.core.Timeline = gsap.timeline();
        const reelHighlight: PIXI.spine.Spine = new PIXI.spine.Spine(BruteForce.assetLoader.getSpineAsset("NudgeReelHighlight"))
        reelHighlight.position.set(BruteForceGameConfig.reelSetPositionX + BruteForceGameConfig.symbolWidth * reelID - 11, 293);
        this.addChild(reelHighlight);
        reelHighlight.name = `reelhighlight${reelID}`;
        reelHighlight.alpha = 0;
        reelHighlightTl.to(reelHighlight, {duration: 0.5, alpha: 1});
        reelHighlightTl.add(() => {
            reelHighlight.state.setAnimation(0, "idle", true);
        }, "<")

        return reelHighlightTl;
    }

    public hideHighlight(reelID: number): gsap.core.Timeline {
        const hideTL: gsap.core.Timeline = gsap.timeline();
        this.children.forEach((item) => {
            if (item.name === `reelhighlight${reelID}`) {
                hideTL.to(<PIXI.spine.Spine>item, {duration: 0.25, alpha: 0})
            }
        });
        return hideTL;
    }

    public emptyReelView(): void {
        this.children.forEach((item => {
            const spineHighlight: PIXI.spine.Spine = <PIXI.spine.Spine>item;
            BruteForceHelper.resetSpineItem(spineHighlight);
            spineHighlight.destroy();
        }))
        this.removeChildren();
    }

    public showSymHighlight(symPos: number, reelNo: number, isIdleToggle: boolean, group?: number): gsap.core.Timeline {
        const highlighTl: gsap.core.Timeline = gsap.timeline();
        const betlineGroup: string = "isBetlineGroupPlaying_" + group;
        const isBetlinePlaying: boolean[][] = (BruteForceBetlineConfig as any)[betlineGroup];
        let sym: BruteForceSymbol | BruteForceXNudgeSymbol;
        if (BruteForce.model.allWinPositions[reelNo][symPos]) {
            if (BruteForce.model.gameData.evaluatedArea[reelNo][symPos] !== "XN") {
                sym = <BruteForceSymbol>BruteForce.allreelsView.reelModels[reelNo].getStopSymbolAt(symPos);
                highlighTl.add(() => {
                    sym.position.set(BruteForceGameConfig.symbolWidth * (reelNo), BruteForceGameConfig.symbolHeight * (symPos));
                    this.addChild(sym);
                }, 0);
                if (!isIdleToggle && !isBetlinePlaying[reelNo][symPos]) {
                    highlighTl.add(sym.setState(BruteForceSymbolStates.WIN), 0);
                    isBetlinePlaying[reelNo][symPos] = true;
                } else if (isIdleToggle) {
                    highlighTl.add(sym.setState(BruteForceSymbolStates.WIN), 0);
                }
            } else {
                sym = <BruteForceXNudgeSymbol>BruteForce.allreelsView.reelModels[reelNo].getStopSymbolAt(0);
                highlighTl.add(sym.setState(BruteForceSymbolStates.WIN), 0);
            }
            highlighTl.add(() => {
                this.position.set(BruteForceGameConfig.reelSetPositionX, BruteForceGameConfig.reelSetPositionY);
            }, 0);
        }
        //  console.log("highlight", highlighTl.totalDuration());
        return highlighTl;
    }

    public resetViewPosition() {
        this.position.set(0, 0);
    };

    public shakeReelOverlay(): gsap.core.Timeline { //prebigwinshake
        const moveXVal: number = 7,
            moveYVal: number = 7,
            shakeTL: gsap.core.Timeline = gsap.timeline(),
            x: string = `+=${moveXVal}`,
            y: string = `+=${moveYVal}`;

        const shakeWiggle = CustomWiggle.create("ReelAreaWiggle", {
            wiggles: 70,
            amplitudeEase: Linear.easeNone,
            timingEase: Linear.easeNone
        });

        shakeTL.to(this, {
            duration: 0.69,
            x: x,
            ease: shakeWiggle
        }, 0);
        shakeTL.to(this, {
            duration: 0.69,
            y: y,
            ease: shakeWiggle
        }, 0);
        shakeTL.to(this, {
            x: BruteForceGameConfig.reelSetPositionX,
            y: BruteForceGameConfig.reelSetPositionY,
            duration: 0.01
        });
        return shakeTL;
    }

    private init() {
        this.scale.set(1.2, 1.2);
    }
}